import { ApiError } from "../api.js";
import { esc } from "../utils.js";
import { postCardHtml, attachPostCardHandlers } from "../postCard.js";
import { infiniteScroll } from "../infiniteScroll.js";
import { navigate } from "../app.js";

/** Following (#/feed): posts from the divers, dive sites, cohorts and dive
 *  events the diver follows, in one list (?feed=following). */

function emptyStateHtml(icon, title, subtitle) {
  return `<div class="dc-empty"><i class="bi ${icon}"></i><div class="fw-semibold">${esc(title)}</div><div>${esc(subtitle)}</div></div>`;
}

/** The scroller on screen, so a new render can stop the old one watching. */
let activeFeed = null;

export function render(container) {
  container.innerHTML = `
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="display-heading h3 mb-0">Following</h1>
      <button class="btn btn-accent" id="new-post-btn"><i class="bi bi-plus-lg me-1"></i>Post</button>
    </div>
    <div id="feed-content"></div>`;

  const content = container.querySelector("#feed-content");
  activeFeed?.destroy();
  activeFeed = infiniteScroll(content, {
    path: "/posts",
    query: { feed: "following" },
    emptyHtml: emptyStateHtml(
      "bi-people",
      "Nothing to show yet",
      "Follow divers and dive sites, or join cohorts and dive events, to see their posts here."
    ),
    // An auth failure is not "no posts": the feed needs a session, and
    // saying so is more useful than an empty state.
    onError: (err) => {
      const isAuthError = err instanceof ApiError && err.status === 401;
      content.innerHTML = isAuthError
        ? emptyStateHtml("bi-lock", "Sign in required", "Log in to see posts from what you follow.")
        : emptyStateHtml("bi-exclamation-triangle", "Could not load posts", err.message || "");
    },
    render: (list, posts) => {
      // Appended rather than replaced: earlier pages stay put, which is
      // the whole point of scrolling.
      const batch = document.createElement("div");
      batch.innerHTML = posts.map(postCardHtml).join("");
      attachPostCardHandlers(batch);
      list.append(batch);
    },
  });

  container.querySelector("#new-post-btn").addEventListener("click", () => navigate("/create-post"));
}
